import React, { Component } from 'react';
import FirstPage from './FirstPage';
import AboutUs from './AboutUs.jsx';
import OurServices from './OurServices.jsx';
import CoverflowEffect from './Gallery.jsx';
import OurProcess from './OurProcess.jsx';
import Counters from './Counters.jsx';
import Testimonials from './Testimonials.jsx';
// import ContactForm from './ContactForm.jsx';
import Map from './Map.jsx';


export default class Home extends Component {
    render() {
        return (
            <div>
                <div style={{visibility: 'hidden', position: 'absolute', zIndex: '1', width: "100%"}}>
                    home renovation services Toronto, professional contractors Greater Toronto Area, quality renovations Hamilton, kitchen updates Toronto, bathroom remodels Hamilton, living room transformations Toronto, bedroom designs Hamilton, home renovation Greater Toronto Area, quality craftsmanship Hamilton. bathroom renovations, kitchen renovations, basement renovations, kitchen remodeling, renovation contractor, bathroom remodelling, kitchen reno, washroom renovations, home renovation contractors, small bathroom renovations, basement contractors, kitchen renovation near me, bathroom contractors near me, home remodeling contractors, home construction companies near me, home renovations near me, kitchen and bathroom renovations, residential contractor, kitchen renovation contractors near me, bedroom renovation, bathroom renovation contractors, kitchen cabinet renovation, basement remodels, small bathroom reno, budget bathroom renovation, kitchen renovation contractor, complete bathroom renovation, kitchen renovation company, basement renovation companies, kitchen renovation companies near me, kitchen construction company, basement bathroom contractors, basement bathroom renovation, bathroom renovations near me, renovation contractors near me, best kitchen remodelers near me, home renovation companies near me, kitchen bathroom renovations, house renovation contractor, bathroom contractors, kitchen contractors, Professional Renovation, kitchen refacing Toronto, complete kitchen, complete bathroom, attention to details, dream kitchen, refacing Toronto, Toronto renovation, kitchen renovation, home renovation, free estimate, refacing, home refacing, bathroom refacing, bathroom renovation, home design, door refacing, countertops, washroom design, cabinet refacing, quartz, granite, counter tops, laminate, affordable price, budget oriented, hi-end renovation, professional refacing, professional renovation, modern refacing, classic refacing, Toronto kitchen refacing, GTA kitchen refacing, Vaughan kitchen refacing, Mississauga kitchen refacing, Oakville kitchen refacing, Markham kitchen refacing, Scarborough kitchen refacing, Richmond Hill kitchen refacing, Burlington kitchen refacing, Brampton kitchen refacing, Kitchen cabinet Toronto, Kitchen Cabinets Painting Toronto, Hamilton renovation
                    <a
                        href='https://homestars.com/'
                    >
                        https://homestars.com/
                    </a>
                    <a
                        href='https://www.yelp.ca/'
                    >
                        https://www.yelp.ca/
                    </a>
                    <a
                        href='https://www.yellowpages.ca/'
                    >
                        https://www.yellowpages.ca/
                    </a>
                </div>
                <FirstPage/>
                <OurServices/>
                <AboutUs/> 
                <Counters/>
                <CoverflowEffect/>
                <OurProcess/>
                <Testimonials/>
                <Map/>
                {/* <ContactForm/> */}
            </div>
        )
    }
}